/**
 * @generated SignedSource<<a05f07f94dfc3c93ddeccb318761260d>>
 * @relayHash b6c6e5fcf34b29914e3ffee7bfac0a54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 91d0f45308135901c28f5eda9ddcf6e8811cac2307a2de1996de6218025f4f2d

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSidebarMenuItemReorderOperation = "AFTER" | "BEFORE" | "MOVE_DOWN" | "MOVE_TO_BOTTOM" | "MOVE_TO_TOP" | "MOVE_UP" | "%future added value";
export type JiraReorderSidebarMenuItemInput = {
  cloudId: string;
  menuItem: JiraSidebarMenuItemInput;
  relativeMenuItem?: JiraSidebarMenuItemInput | null;
  reorderMode: JiraSidebarMenuItemReorderOperation;
};
export type JiraSidebarMenuItemInput = {
  itemId: string;
};
export type useSyncChangeFavouritesMutation$variables = {
  input: JiraReorderSidebarMenuItemInput;
};
export type useSyncChangeFavouritesMutation$data = {
  readonly jira_reorderProjectsSidebarMenuItem: {
    readonly favourites: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly projectKey: string;
          readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectMenuItem">;
        } | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    } | null;
    readonly id: string;
  } | null;
};
export type useSyncChangeFavouritesMutation = {
  response: useSyncChangeFavouritesMutation$data;
  variables: useSyncChangeFavouritesMutation$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": isActionMenuWithAddPeopleSpotlightIdEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider: {
    readonly get: () => boolean;
  };
});

import isActionMenuWithAddPeopleSpotlightIdEnabled_provider from '@jira/platform__graphql-relay-provider/src/JsmEnableActionMenuAddPeopleSpotlightIdRelayProvider';
import isSubspaceEnabled_provider from '@jira/platform__graphql-relay-provider/src/atlas-project-native-integration-m2.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  }
],
v4 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v5 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSyncChangeFavouritesMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_reorderProjectsSidebarMenuItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "Nav4ProjectMenuItem"
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ],
            "storageKey": "favourites(first:15)"
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
      }
    ],
    "kind": "Operation",
    "name": "useSyncChangeFavouritesMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_reorderProjectsSidebarMenuItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectType"
                      },
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "large"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "defaultNavigationItem",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_PROJECT_CONFIG"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canPerform"
                          }
                        ],
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "softwareBoardCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "webUrl"
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": "subspaceCount",
                                "kind": "ScalarField",
                                "name": "subspaceCount_cse"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ],
            "storageKey": "favourites(first:15)"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "91d0f45308135901c28f5eda9ddcf6e8811cac2307a2de1996de6218025f4f2d",
    "metadata": {},
    "name": "useSyncChangeFavouritesMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": isActionMenuWithAddPeopleSpotlightIdEnabled_provider
    }
  }
};
})();

(node as any).hash = "0bc215ec8f9afc0553a13bec6bde53dd";

export default node;
